export default [
  {
    path: '/',
    name: 'home',
    pageNameMask: 'home',
    component: require('~/pages/home.vue').default
  },
  {
    path: '/courses/:id',
    name: 'course.view',
    pageNameMask: 'course_:id',
    component: require('~/pages/courses/view.vue').default
  },
  {
    path: '/courses',
    name: 'courses',
    component: { name: 'home' },
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: require('~/pages/agreement.vue').default,
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: require('~/pages/cookies.vue').default,
  },
  {
    path: '/partnership',
    name: 'partnership',
    component: require('~/pages/partnership.vue').default,
  },
  {
    path: '/faq',
    name: 'faq',
    component: require('~/pages/faq.vue').default,
  },
  {
    path: '/support',
    name: 'support',
    component: require('~/pages/support.vue').default,
  },
  // открываем доступ к урокам для всех
  {
    path: '/courses/:courseId/lessons/:id',
    name: 'lesson.view',
    pageNameMask: 'course_:courseId_lesson_:id',
    component: require('~/pages/lessons/view.vue').default
  },
  {
    path: '/courses/:courseId/lessons/:lessonId/tests/:id',
    name: 'tests.view',
    pageNameMask: 'course_:courseId_lesson_:lessonId_tests_:id',
    component: require('~/pages/tests/view.vue').default
  },
  // Authenticated routes.
  ...middleware('auth',
    [
      {
        path: '/settings',
        pageNameMask: 'settings',
        component: require('~/pages/settings/index.vue').default,
        children: [
          {
            path: '',
            name: 'settings',
            pageNameMask: 'settings',
            redirect: {name: 'settings.profile'}
          },
          {
            path: 'profile',
            name: 'settings.profile',
            pageNameMask: 'profile',
            component: require('~/pages/settings/profile.vue').default
          },
          {
            path: 'stats',
            name: 'settings.stats',
            pageNameMask: 'stats',
            component: require('~/pages/settings/stats.vue').default
          },
          {
            path: 'password',
            name: 'settings.password',
            pageNameMask: 'password',
            component: require('~/pages/settings/password.vue').default
          }
        ]
      },
      // открываем доступ к урокам для всех
      // {
      //   path: '/courses/:courseId/lessons/:id',
      //   name: 'lesson.view',
      //   pageNameMask: 'course_:courseId_lesson_:id',
      //   component: require('~/pages/lessons/view.vue').default
      // },
      // {
      //   path: '/courses/:courseId/lessons/:lessonId/tests/:id',
      //   name: 'tests.view',
      //   pageNameMask: 'course_:courseId_lesson_:lessonId_tests_:id',
      //   component: require('~/pages/tests/view.vue').default
      // },
      ...middleware('teacher', [
        {
          path: '/admin',
          name: 'admin',
          component: require('~/pages/admin/index.vue').default,
          children: [
            {
              path: 'courses/edit/:id',
              name: 'admin.course.edit',
              component: require('~/pages/admin/courses/edit.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/create',
              name: 'admin.lesson.add',
              component: require('~/pages/admin/lessons/add.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/edit/:id',
              name: 'admin.lesson.edit',
              component: require('~/pages/admin/lessons/edit.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/:lessonId/tests/:testId/questions/create',
              name: 'admin.question.add',
              component: require('~/pages/admin/questions/add.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/:lessonId/tests/:testId/questions/edit/:id',
              name: 'admin.question.edit',
              component: require('~/pages/admin/questions/edit.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/:lessonId/tests/:testId/questions/:questionId/variants/create',
              name: 'admin.variant.add',
              component: require('~/pages/admin/variants/add.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/:lessonId/tests/:testId/questions/:questionId/variants/edit/:id',
              name: 'admin.variant.edit',
              component: require('~/pages/admin/variants/edit.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/:lessonId/tests/create',
              name: 'admin.test.add',
              component: require('~/pages/admin/tests/add.vue').default,
            },
            {
              path: 'courses/:courseId/lessons/:lessonId/tests/edit/:id',
              name: 'admin.test.edit',
              component: require('~/pages/admin/tests/edit.vue').default,
            },
            ...middleware('curator', [
              {
                path: 'users',
                name: 'admin.users',
                component: require('~/pages/admin/users/index.vue').default,
              },
              {
                path: 'users/stats/:id',
                name: 'admin.user.stats',
                component: require('~/pages/admin/users/stats.vue').default,
              },
              {
                path: 'users/view/:id',
                name: 'admin.user.view',
                component: require('~/pages/admin/users/view.vue').default,
              },
              {
                path: 'courses',
                name: 'admin.courses',
                component: require('~/pages/admin/courses/index.vue').default,
              },
              {
                path: 'courses/create',
                name: 'admin.course.add',
                component: require('~/pages/admin/courses/add.vue').default,
              },
              {
                path: 'tests',
                name: 'admin.tests',
                component: require('~/pages/admin/tests/index.vue').default,
              },
              ...middleware('admin',
                [
                  {
                    path: 'users/create',
                    name: 'admin.user.add',
                    component: require('~/pages/admin/users/add.vue').default,
                  },
                  {
                    path: 'users/edit/:id',
                    name: 'admin.user.edit',
                    component: require('~/pages/admin/users/edit.vue').default,
                  },
                  {
                    path: 'partners',
                    name: 'admin.partners',
                    component: require('~/pages/admin/partners/index.vue').default,
                  },
                  {
                    path: 'partners/create',
                    name: 'admin.partner.add',
                    component: require('~/pages/admin/partners/add.vue').default,
                  },
                  {
                    path: 'partners/edit/:id',
                    name: 'admin.partner.edit',
                    component: require('~/pages/admin/partners/edit.vue').default,
                  },

                  {
                    path: 'pages/main',
                    name: 'admin.pages.main',
                    component: require('~/pages/admin/pages/main.vue').default,
                  },
                  {
                    path: 'pages/agreement',
                    name: 'admin.pages.agreement',
                    component: require('~/pages/admin/pages/agreement.vue').default
                  },
                  {
                    path: 'pages/cookies',
                    name: 'admin.pages.cookies',
                    component: require('~/pages/admin/pages/cookies.vue').default
                  },
                  {
                    path: 'pages/support',
                    name: 'admin.pages.support',
                    component: require('~/pages/admin/pages/support.vue').default
                  },
                  {
                    path: 'pages/faq',
                    name: 'admin.pages.faq',
                    component: require('~/pages/admin/pages/faq.vue').default
                  },
                  {
                    path: 'pages/partnership',
                    name: 'admin.pages.partnership',
                    component: require('~/pages/admin/pages/partnership.vue').default
                  },
                ]),
            ]),
          ],
        }
      ]),
      // Guest routes.
      ...middleware('guest',
        [
          {
            path: '/login',
            name: 'login',
            pageNameMask: 'login',
            component: require('~/pages/auth/login.vue').default
          },
          {
            path: '/register',
            name: 'register',
            pageNameMask: 'register',
            component: require('~/pages/auth/register.vue').default
          },
          {
            path: '/register/confirmed',
            name: 'register.confirmed',
            pageNameMask: 'register_confirmed',
            component: require('~/pages/auth/confirmed.vue').default
          },
          {
            path: '/register/confirmation',
            name: 'register.confirmation',
            pageNameMask: 'register_confirmation',
            component: require('~/pages/auth/confirmation.vue').default
          },
          {
            path: '/register/wrongConfirmationCode',
            name: 'register.wrongConfirmationCode',
            pageNameMask: 'register_confirmation_wrong',
            component: require('~/pages/auth/exceptions/wrongConfirmationCode.vue').default
          },
          {
            path: '/register/confirmationCodeException',
            name: 'register.confirmationCodeException',
            pageNameMask: 'register_confirmation_wrong',
            component: require('~/pages/auth/exceptions/confirmationCodeException.vue').default
          },
          {
            path: '/password/linkSent',
            name: 'password.linkSent',
            pageNameMask: 'password_sent',
            component: require('~/pages/auth/password/linkSent.vue').default
          },
          {
            path: '/password/success',
            name: 'password.success',
            pageNameMask: 'password_success',
            component: require('~/pages/auth/password/success.vue').default
          },
          {
            path: '/password/reset/:token',
            name: 'password.reset',
            pageNameMask: 'password_reset',
            component: require('~/pages/auth/password/reset.vue').default
          }
        ])  ,
      {
        path: '*',
        pageNameMask: '404',
        component: require('~/pages/errors/404.vue').default
      }
    ]
  )
];

/**
 * @param  {String|Function} middleware
 * @param  {Array} routes
 * @return {Array}
 */
function middleware(middleware, routes) {
  routes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  );
  return routes
}
